import React, { useCallback, useEffect, useState } from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
  Stack,
  Paper,
  Chip,
  Divider,
  LinearProgress,
  Avatar,
  TextField,
  Checkbox,
  Button,
  Tooltip,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import useResponsive from '../../../../Hooks/useResponsive';
import { debounce } from 'lodash';

const AccordionComponentForSelf = ({
  title,
  details,
  expandedParameterNames,
  setExpandedParameterNames,
  mainData,
  setData,
  parameters,
  touchedFields,
  setTouchedFields,
  errors,
  setErrors,
  moduleAverages,
  setModuleAverages,
  managerView,
  viewOnly,
  downloadButtonClicked,
}) => {
  const mdUp = useResponsive('up', 'md');
  const handleExpandClick = useCallback((event, title) => {
    event.stopPropagation();
    setExpandedParameterNames((prev) => {
      return prev.includes(title) ? prev.filter((id) => id !== title) : [...prev, title];
    });
  }, []);

  //BY DEFAULT SETTING EVERY PARAMETER NAME/MODULE NAME AND WIHT USER AND MANGER VALUE 0
  useEffect(() => {
    if (managerView || viewOnly) {
      setModuleAverages({ ...mainData.moduleAverages });
    } else {
      setModuleAverages(
        parameters.reduce((acc, key) => {
          acc[key] = { user: 0, manager: 0 };
          return acc;
        }, {})
      );
    }
  }, []);

  // const RatingOrCommentOrNaChange = useCallback(
  //   debounce((value, title, index, evaluationType, person) => {
  //     setData((prev) => {
  //       // Clone the target module array (goal/kra/skill/etc.)
  //       const updatedModule = [...prev[title]];

  //       // Clone the specific item
  //       const updatedItem = { ...updatedModule[index] };

  //       // Clone the evaluation object
  //       const updatedEvaluation = {
  //         ...updatedItem.evaluation,
  //         [person]: {
  //           ...updatedItem.evaluation[person],
  //           [evaluationType]: value,
  //         },
  //       };

  //       // Assign updated evaluation back to the item
  //       updatedItem.evaluation = updatedEvaluation;

  //       // Replace the item in the array
  //       updatedModule[index] = updatedItem;

  //       // Return updated state
  //       return {
  //         ...prev,
  //         [title]: updatedModule,
  //       };
  //     });
  //   }, 300),

  //   []
  // );

  const RatingOrCommentOrNaChange = (value, title, index, evaluationType, person) => {
    const newRatingOrComment = evaluationType == 'rating' ? Number(value) : value;
    //IF THE TYPE IS RATING THEN IT WILL CONVERT AS NUMBER IN OHTER CASE OF COMMENT AND N/A IT WILL ACCEPT AS THE SAME VALUE
    setData((prev) => {
      // Clone the target module array (goal/kra/skill/etc.) FORM TH ENTIRE DATA
      const updatedModule = [...prev[title]];

      // Clone the specific item FROM THE ARRAY BY USING INDEX
      const updatedItem = { ...updatedModule[index] };

      // Clone the evaluation object
      const updatedEvaluation = {
        ...updatedItem.evaluation,
        [person]: {
          ...updatedItem.evaluation[person],
          [evaluationType]: newRatingOrComment, //NEW RATING VALUE ADDED,IF THE N/A COMES ALSO REMOVING THE ENTERED RATING IN CORRESPONDING OBJECT
          ...(evaluationType === 'na' ? { rating: null } : {}),
        },
      };

      // Assign updated evaluation back to the item
      updatedItem.evaluation = updatedEvaluation;

      // Replace the item in the array
      updatedModule[index] = updatedItem;

      // Return updated state
      moduleAverageCalculation(title, updatedModule, person); //HERE CALUCULATING THE MODULE RATING SCORE
      return {
        //STATE ALREADY CHAGED
        ...prev,
        [title]: updatedModule,
      };
    });
  };

  const getFieldKey = (title, index, type, person) => `${title}-${index}-${type}-${person}`;

  const moduleAverageCalculation = (title, updatedModule, person) => {
    // filtered out items marked as NA IF ANY NA MARKED THAT OBJECT CORRESPONDING TO THE MODULE NOT TAKEN BELOW FOR CALCULATION
    const module = updatedModule.filter((data) => data.evaluation[person].na == false);

    if (!module || !Array.isArray(module) || module.length === 0) {
      // nothing to calculate
      setModuleAverages((prev) => ({
        ...prev,
        [title]: {
          ...prev[title],
          [person]: 0,
        },
      }));
      return;
    }
    // how many decimal points you want to round to
    const decimalPoints = mainData.rating.decimalPoints || 1;
    // calculate weightage per item
    const appraisalWeightageTotal = module.map((data) => {
      const weight = data?.appraisal_weightage;
      const safeWeight = weight === null || weight === undefined ? 100 : weight;
      return safeWeight / 100; //[0.2,0.3...]
    });

    // sum of all weightages NOW DENOMINATOR BECOME A SINGLE VALUE
    const denominator = appraisalWeightageTotal.reduce((acc, data) => acc + data, 0);
    const arrayOfEachValues = [];
    module.forEach((item, index) => {
      const rating = item?.evaluation?.[person]?.rating;
      if (typeof rating === 'number') {
        arrayOfEachValues.push(rating * appraisalWeightageTotal[index]); //the value is pushing to array after multiplyig the user rating * maxm appraisalweightage
      }
    });

    const numerator = arrayOfEachValues.reduce((acc, data) => acc + data, 0);
    const sum = numerator / denominator;
    const roundedSum = Number(sum.toFixed(decimalPoints));

    setModuleAverages((prev) => ({
      ...prev,
      [title]: {
        ...prev[title],
        [person]: roundedSum,
      },
    }));
  };

  const [userAllowedFields, setUserAllowedFields] = useState({
    ratings: !!mainData?.config?.selfApparaisal?.parameters?.find(
      (param) => param.name.toLowerCase() === title.toLowerCase()
    )?.ratings,
    comments: !!mainData?.config?.selfApparaisal?.parameters?.find(
      (param) => param.name.toLowerCase() === title.toLowerCase()
    )?.comments,
  });
  const [managerAllowedFields, setManagerAllowedFields] = useState({
    ratings: !!mainData?.config?.managerReview?.parameters?.find(
      (param) => param.name.toLowerCase() === title.toLowerCase()
    )?.ratings,
    comments: !!mainData?.config?.managerReview?.parameters?.find(
      (param) => param.name.toLowerCase() === title.toLowerCase()
    )?.comments,
  });
  return (
    <Paper elevation={4}>
      <Accordion expanded={expandedParameterNames.includes(title)} onChange={(e) => handleExpandClick(e, title)}>
        <AccordionSummary sx={{ backgroundColor: '#f5f5f5' }} expandIcon={<ExpandMoreIcon />}>
          <Box
            sx={{
              width: '100%',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <Box>
              <Typography
                variant="overline"
                fontWeight={600}
                textTransform="uppercase"
                color="text.secondary"
                letterSpacing={1}
                sx={{
                  fontSize: { xs: '0.65rem', md: '0.75rem' },
                  display: 'flex',
                  alignItems: 'center',
                  gap: 0.5,
                }}
              >
                {title.replace(/_/g, ' ')} -{' '}
                <Box
                  component="span"
                  sx={{
                    fontWeight: 'bold',
                    color: 'text.secondary',
                    fontSize: { xs: '0.55rem', md: '0.7rem' },
                  }}
                >
                  {details?.length || 0}
                </Box>
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.2 }} mr={mdUp ? 1 : 0}>
              {true && (
                <Typography
                  variant="overline"
                  sx={{
                    fontSize: { xs: '0.5rem', md: '0.55rem' },
                    color: 'text.secondary',
                    visibility: userAllowedFields?.ratings ? 'visible' : 'hidden',
                  }}
                >
                  Self Appraisal Total Average : {moduleAverages[title]?.user}
                </Typography>
              )}

              {managerView && managerAllowedFields?.ratings && (
                <Typography
                  variant="overline"
                  sx={{
                    fontSize: { xs: '0.5rem', md: '0.55rem' },
                    color: 'text.secondary',
                  }}
                >
                  Reviewer Total Average : {moduleAverages[title]?.manager}
                </Typography>
              )}
            </Box>
          </Box>
        </AccordionSummary>

        <AccordionDetails sx={{ maxHeight: downloadButtonClicked?'': '70vh', overflowY: 'auto' }}>
          <Stack spacing={1}>
            {Array.isArray(details) &&
              details.map((item, index) => (
                <Box
                  key={item?.id}
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    // gap: 2,
                    p: 1,
                    borderRadius: 1,
                    backgroundColor: '#f5f5f5',
                  }}
                >
                  <Box p={1.5} sx={{ backgroundColor: 'white', borderColor: 'grey.300' }}>
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        gap: 1,
                        mb: 0.5,
                      }}
                    >
                      <Typography variant="body2" fontWeight="bold" color="text.primary">
                        {index + 1}. {item?.name}
                      </Typography>
                      {item?.tags && (
                        <Box
                          sx={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            gap: 1,
                            alignItems: 'center ',
                          }}
                        >
                          {item?.tags.map((tag, index) => (
                            <Chip
                              key={`${tag?.id}-${index}`}
                              label={tag?.name}
                              size="small"
                              sx={{
                                color: tag?.color || 'black',
                                fontSize: {
                                  xs: '0.6rem',
                                  sm: '0.7rem',
                                },
                                fontWeight: 600,
                                p: 1,
                              }}
                            />
                          ))}
                        </Box>
                      )}
                    </Box>

                    {item?.completedPercentage !== undefined && (
                      <Box sx={{ width: '100%', mt: 0.5, pl: 1.7, pr: 0.5 }}>
                        <LinearProgress
                          variant="determinate"
                          value={item?.completedPercentage ?? 50}
                          sx={{
                            height: 3,
                            borderRadius: '4px',
                            backgroundColor: '#eee',
                            '& .MuiLinearProgress-bar': {
                              backgroundColor:
                                item?.completedPercentage >= 90
                                  ? '#4fff00'
                                  : item?.completedPercentage >= 50
                                  ? '#ffd600'
                                  : '#ff0000',
                            },
                          }}
                        />
                        <Box
                          mt={0.4}
                          sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            flexWrap: 'wrap',
                          }}
                        >
                          <Typography
                            variant="caption"
                            sx={{
                              fontSize: '0.6rem',
                              fontWeight: 'bold',
                              color: '#555',
                            }}
                          >
                            {item?.completedPercentage ?? 0}%
                          </Typography>

                          <Box
                            sx={{
                              display: 'flex',
                              gap: 1,
                              alignItems: 'center',
                            }}
                          >
                            <Typography
                              variant="caption"
                              sx={{
                                fontSize: '0.6rem',
                                fontWeight: 'bold',
                                color: '#555',
                              }}
                              textTransform={'capitalize'}
                            >
                              {item?.status}
                              {item?.statusMessage ? ` (${item?.statusMessage})` : ''}
                            </Typography>
                          </Box>
                        </Box>
                      </Box>
                    )}

                    <Box mt={0.5}>
                      <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{ pl: 1.6, fontSize: '0.75rem', lineHeight: 1.5 }}
                      >
                        {item?.description}
                      </Typography>
                    </Box>
                  </Box>
                  <Divider />

                  {/* USER ACTIONS START >>>>>>>>>>>>>>>>>>>>>*/}
                  <Box sx={{ backgroundColor: 'white', width: '100%' }} p={1}>
                    <Stack
                      direction={mdUp ? 'row' : 'column'}
                      gap={2}
                      justifyContent={'space-between'}
                      alignItems={mdUp ? 'center' : 'flex-start'}
                      sx={{ width: '100%' }}
                    >
                      {/* USER DETAILS CHIP SECTION START */}
                      <Box sx={{ width: mdUp ? '20%' : '100%' }}>
                        <Stack
                          direction="row"
                          alignItems="center"
                          spacing={1.5}
                          sx={{
                            pl: 1,
                            pr: 2,
                            py: 0.5,
                            borderRadius: 1,
                            backgroundColor: 'whitesmoke',
                            width: 'fit-content',
                            boxShadow: 5,
                          }}
                        >
                          <Avatar
                            alt={mainData?.user?.name || 'User'}
                            src={`https://workspace.teaminterval.net/assets/employee/photo/passport_size/${mainData?.user?.photo}.jpg`}
                            sx={{ width: 40, height: 40 }}
                          />
                          <Chip
                            label={
                              <Typography sx={{ fontSize: '0.6rem', color: 'black' }} variant="body2" fontWeight={200}>
                                {mainData?.user?.name || 'N/A'}
                              </Typography>
                            }
                            variant="filled"
                            sx={{
                              height: 22,
                              px: 2,
                              color: '#c4cdd5',
                            }}
                          />
                        </Stack>
                      </Box>
                      {/* USER DETAILS CHIP SECTION END */}

                      {/* USER RATING SECTION START */}
                      {userAllowedFields?.ratings && ( //IF THE USER ALLOWED TO RATE HIM SELF THEN TRUE
                        <Box
                          pl={downloadButtonClicked ? 5 : 0}
                          sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: mdUp ? 'center' : 'flex-start',
                            justifyContent: 'flex-start',
                            width: mdUp ? '30%' : '100%',
                          }}
                        >
                          <Box sx={{ display: 'flex', gap: 1, pl: mdUp ? 3 : 0 }}>
                            <TextField
                              onWheel={(e) => e.target.blur()}
                              disabled={item.evaluation.user.na || managerView || viewOnly}
                              type="number"
                              inputProps={{
                                min: mainData?.rating?.range?.min || 1,
                                max: mainData?.rating?.range?.max || 5,
                              }}
                              // onKeyDown={(e) => {
                              //   const allowedKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab', 'Delete'];
                              //   const key = e.key;
                              //   const nextValue = e.currentTarget.value + key;
                              //   if (
                              //     !allowedKeys.includes(key) &&
                              //     (isNaN(Number(key)) || Number(nextValue) > (mainData?.rating?.range?.max || 5))
                              //   ) {
                              //     e.preventDefault();
                              //   }
                              // }}
                              value={item?.evaluation?.user?.rating || ''}
                              onChange={(e) => {
                                const value = e.target.value;
                                const number = Number(value);
                                const max = mainData?.rating?.range?.max || 5;
                                const min = mainData?.rating?.range?.min || 1;
                                const decimalPoints = mainData.rating.decimalPoints || 1;
                                const splitedAfterDecimal = value.toString().split('.');
                                const isValidDecimal =
                                  !splitedAfterDecimal[1] || splitedAfterDecimal[1].length <= decimalPoints;

                                if (
                                  value === '' ||
                                  (!isNaN(number) && number <= max && number >= min && isValidDecimal)
                                ) {
                                  RatingOrCommentOrNaChange(value, title, index, 'rating', 'user');
                                }
                              }}
                              sx={{
                                width: '50px',
                                '& .MuiInputBase-root': {
                                  height: '23px',
                                },
                                '& input': {
                                  height: '100%',
                                  boxSizing: 'border-box',
                                  textAlign: 'center',
                                },
                              }}
                            />
                            <Typography variant="body1">/{mainData?.rating?.range?.max}</Typography>
                          </Box>

                          {mainData?.rating?.includeNA && true && (
                            <Box display="flex" alignItems="center">
                              <Checkbox
                                disabled={managerView || viewOnly}
                                size="small"
                                sx={{ p: 0.5 }}
                                checked={item?.evaluation?.user?.na || false}
                                onChange={(e) =>
                                  RatingOrCommentOrNaChange(e.target.checked, title, index, 'na', 'user')
                                }
                              />
                              <Typography variant="caption" sx={{ ml: 0.5 }}>
                                N/A
                              </Typography>
                            </Box>
                          )}
                        </Box>
                      )}
                      {/* USER RATING SECTION END */}

                      {/* USER COMMENT SCTION IS ALLOWED THEN ONLY SHOW THIS COMPONENT START */}
                      {userAllowedFields?.comments && (
                        <Box sx={{ width: mdUp ? '50%' : '100%', pl: !userAllowedFields?.ratings && mdUp ? 2 : 0 }}>
                          <Box>
                            {/* <Tooltip
                              title={((managerView || viewOnly) && item?.evaluation?.user?.comment) || ''}
                              placement="top"
                              arrow
                            > */}
                            <TextField
                              disabled={managerView || viewOnly}
                              multiline
                              minRows={1}
                              placeholder="Enter your comment"
                              {...((managerView || viewOnly) && { value: item?.evaluation?.user?.comment || '' })}
                              onBlur={(e) => {
                                const value = e.target.value;
                                const key = getFieldKey(title, index, 'comment', 'user');
                                setTouchedFields((prev) => ({
                                  ...prev,
                                  [key]: true,
                                }));
                                const minLen = mainData?.rating?.minimumCommentLength || 0;
                                setErrors((prev) => ({
                                  ...prev,
                                  [key]: value.length < minLen ? `Minimum ${minLen} characters required.` : '',
                                }));

                                RatingOrCommentOrNaChange(value, title, index, 'comment', 'user');
                              }}
                              fullWidth
                              sx={{
                                '& .MuiInputBase-root': {
                                  width: '100%',
                                  alignItems: 'flex-start', // aligns text at the top for multiline
                                },
                                '& .MuiInputBase-input': {
                                  // height: viewOnly?'':'100% !important',
                                  overflow: 'auto',
                                },
                              }}
                              error={
                                touchedFields[getFieldKey(title, index, 'comment', 'user')] &&
                                !!errors[getFieldKey(title, index, 'comment', 'user')]
                              }
                              helperText={
                                touchedFields[getFieldKey(title, index, 'comment', 'user')] &&
                                errors[getFieldKey(title, index, 'comment', 'user')]
                              }
                            />
                            {/* </Tooltip> */}
                          </Box>
                        </Box>
                      )}

                      {/* USER COMMENT SCTION IS ALLOWED THEN ONLY SHOW THIS COMPONENT END*/}
                    </Stack>
                  </Box>
                  {/* USER ACTIONS END <<<<<<<<<<<<<<<<<<<<<<<*/}

                  <Divider />
                  {/* ......................................................... */}

                  {/* MANAGER ACTIONS START >>>>>>>>>>>>>>>>>>>>>*/}
                  {managerView && (
                    <Box sx={{ backgroundColor: 'white', width: '100%' }} p={1}>
                      <Stack
                        direction={mdUp ? 'row' : 'column'}
                        gap={2}
                        justifyContent={'space-between'}
                        alignItems={mdUp ? 'center' : 'flex-start'}
                        sx={{ width: '100%' }}
                      >
                        {/* MANAGER DETAILS CHIP SECTION START */}
                        <Box sx={{ width: mdUp ? '20%' : '100%' }}>
                          <Stack
                            direction="row"
                            alignItems="center"
                            spacing={1.5}
                            sx={{
                              pl: 1,
                              pr: 2,
                              py: 0.5,
                              borderRadius: 1,
                              backgroundColor: 'whitesmoke',
                              width: 'fit-content',
                              boxShadow: 5,
                            }}
                          >
                            <Avatar
                              alt={mainData?.manager?.name || 'User'}
                              src={`https://workspace.teaminterval.net/assets/employee/photo/passport_size/${mainData?.manager?.photo}.jpg`}
                              sx={{ width: 40, height: 40 }}
                            />
                            <Chip
                              label={
                                <Typography
                                  sx={{ fontSize: '0.6rem', color: 'black' }}
                                  variant="body2"
                                  fontWeight={200}
                                >
                                  {mainData?.manager?.name || 'N/A'}
                                </Typography>
                              }
                              variant="filled"
                              sx={{
                                height: 22,
                                px: 2,
                                color: '#c4cdd5',
                              }}
                            />
                          </Stack>
                        </Box>
                        {/* MANAGER DETAILS CHIP SECTION END */}

                        {/* MANAGER RATING SECTION START */}
                        {managerAllowedFields?.ratings && ( //IF THE MANAGER ALLOWED TO RATE HIM SELF THEN TRUE
                          <Box
                            pl={downloadButtonClicked ? 5 : 0}
                            sx={{
                              display: 'flex',
                              flexDirection: 'column',
                              alignItems: mdUp ? 'center' : 'flex-start',
                              justifyContent: 'flex-start',
                              width: mdUp ? '30%' : '100%',
                            }}
                          >
                            <Box
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1,
                                pl: mdUp ? 3 : 0,
                              }}
                            >
                              <TextField
                                onWheel={(e) => e.target.blur()}
                                disabled={item.evaluation.manager.na || viewOnly}
                                type="number"
                                value={item?.evaluation?.manager?.rating || ''}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  const number = Number(value);
                                  const max = mainData?.rating?.range?.max || 5;
                                  const min = mainData?.rating?.range?.min || 1;
                                  const decimalPoints = mainData.rating.decimalPoints || 1;
                                  const splitedAfterDecimal = value.toString().split('.');
                                  const isValidDecimal =
                                    !splitedAfterDecimal[1] || splitedAfterDecimal[1].length <= decimalPoints;

                                  if (
                                    value === '' ||
                                    (!isNaN(number) && number <= max && number >= min && isValidDecimal)
                                  ) {
                                    RatingOrCommentOrNaChange(e.target.value, title, index, 'rating', 'manager');
                                  }
                                }}
                                sx={{
                                  width: '50px',
                                  '& .MuiInputBase-root': {
                                    height: '20px',
                                  },
                                  '& input': {
                                    height: '100%',
                                    boxSizing: 'border-box',
                                    textAlign: 'center',
                                  },
                                }}
                              />
                              <Typography variant="body1">/{mainData?.rating?.range?.max}</Typography>
                            </Box>

                            {mainData?.rating?.includeNA &&
                              true && ( //IF N/A APPLICABLE THEN ONLY SHOW
                                <Box display="flex" alignItems="center">
                                  <Checkbox
                                    disabled={viewOnly}
                                    size="small"
                                    sx={{ p: 0.5 }}
                                    checked={item?.evaluation?.manager?.na || false}
                                    onChange={(e) =>
                                      RatingOrCommentOrNaChange(e.target.checked, title, index, 'na', 'manager')
                                    }
                                  />
                                  <Typography variant="caption" sx={{ ml: 0.5 }}>
                                    N/A
                                  </Typography>
                                </Box>
                              )}
                          </Box>
                        )}
                        {/* MANAGER RATING SECTION END */}

                        {/* MANAGER COMMENT SCTION IS ALLOWED THEN ONLY SHOW THIS COMPONENT START */}
                        {managerAllowedFields?.comments && (
                          <Box sx={{ width: mdUp ? '50%' : '100%' }}>
                            <Box>
                              <TextField
                                disabled={viewOnly}
                                multiline
                                minRows={1}
                                placeholder="Enter your comment"
                                {...(viewOnly && {
                                  value: item?.evaluation?.manager?.comment || '',
                                })}
                                onBlur={(e) => {
                                  const value = e.target.value;
                                  const key = getFieldKey(title, index, 'comment', 'manager');
                                  setTouchedFields((prev) => ({
                                    ...prev,
                                    [key]: true,
                                  }));
                                  const minLen = mainData?.rating?.minimumCommentLength || 0;
                                  setErrors((prev) => ({
                                    ...prev,
                                    [key]: value.length < minLen ? `Minimum ${minLen} characters required.` : '',
                                  }));

                                  RatingOrCommentOrNaChange(value, title, index, 'comment', 'manager');
                                }}
                                fullWidth
                                sx={{
                                  '& .MuiInputBase-root': {
                                    width: '100%',
                                    alignItems: 'flex-start', // aligns text at the top for multiline
                                  },
                                  '& .MuiInputBase-input': {
                                    // height: viewOnly?'':'100% !important',
                                    overflow: 'auto',
                                  },
                                }}
                                error={
                                  touchedFields[getFieldKey(title, index, 'comment', 'manager')] &&
                                  !!errors[getFieldKey(title, index, 'comment', 'manager')]
                                }
                                helperText={
                                  touchedFields[getFieldKey(title, index, 'comment', 'manager')] &&
                                  errors[getFieldKey(title, index, 'comment', 'manager')]
                                }
                              />
                            </Box>
                          </Box>
                        )}

                        {/* USER COMMENT SCTION IS ALLOWED THEN ONLY SHOW THIS COMPONENT END*/}
                      </Stack>
                    </Box>
                  )}
                  {/* MANAGER ACTIONS END <<<<<<<<<<<<<<<<<<<*/}
                </Box>
              ))}
          </Stack>
        </AccordionDetails>
      </Accordion>
    </Paper>
  );
};

export default AccordionComponentForSelf;
